'use strict';

/*global jQuery*/
import './features';
import './polyfills';
import * as helpers from './helpers';
import * as lightbox from './lightbox';
import * as tabs from './tabs';
import * as slider from './slider';
import * as cookieConsent from './cookieconsent';
import * as quickSupport from './quicksupport';
import * as accordion from './accordion';
import * as pdfAction from './pdfaction';
import * as navigation from './navigation';
import * as productGallery from './gallery';
import * as siteSearch from './search';
import * as scrollLine from './scrollline';
import * as tooltip from './tooltip';
import * as vectorMap from './vmap';
import * as eventsList from './eventslist';
import * as vimeo from './vimeo';
import * as newsLetterAction from './newsletter-action';
import * as validateSettings from './validate-settings';
import * as categories from './categories';
import * as numberformat from './numberformat';
import * as campaignQuestions from './campaign-questions';
import * as starRating from './star-rating';
import * as omega3 from './omega3-calculator';

//Add an alias to the App, if we need to call App from the outside:
window.App = window.App || {};

window.App.lightbox = lightbox;
window.App.tabs = tabs;
window.App.slider = slider;
window.App.helpers = helpers;


window.App.common = {
    // App.common.init runs on all pages
    init() {

        scrollLine.init();

        campaignQuestions.init();

        lightbox.init({
            defaultLightbox: '.lightbox',
            elasticLightbox: '.lightbox-elastic',
            noOverlayLightbox: '.lightbox-nooverlay',
            galleryLightbox: '.lightbox-gallery',
            galleryThumbsLightbox: '.lightbox-gallery-thumbs',
            iframeLightbox: '.lightbox-iframe',
            flashLightbox: '.lightbox-flash',
            ajaxLightbox: '.lightbox-ajax',
            inlineLightbox: '.lightbox-inline',
            videoLightbox: 'a.video'
        });

        validateSettings.init();

        tabs.init('.tabs ul.tabs-nav');

        cookieConsent.init('#siteCookieContent');

        categories.init('#data-categories-select');

        quickSupport.init();

        accordion.init();

        pdfAction.init();

        tooltip.init('.tooltip');

        vectorMap.init('.region-map');

        eventsList.init('#events')

        newsLetterAction.init();

        numberformat.init('#flexjob-calculator');

        navigation.init();

        productGallery.init();

        siteSearch.init();

        vimeo.init();

        starRating.init();

        if($('.cart-summary tr').length === 1){
            $('.cart-summary .table--tight').css('maxWidth', '360px')
        }
        $.each(helpers, function(){
            if(typeof this === 'function'){
                this.call(this);
            }
        });


    },
    slider() {
        slider.init({
            heroSlider: '.slider--large',
            listSlider: '.slider--list'
        });
    },
    omega3
};


/**
 * Initial Application bootstrapping
 */

// jQuery document ready
(($) => {
    window.App.common.init();
})(jQuery);

// Window onload
window.onload = () => {
    window.App.common.slider();
};